import { createRoutine } from 'redux-saga-routines'

export const SET = 'PROTAGONISTAS/SET'
export const CONTENT = createRoutine('PROTAGONISTAS/CONTENT')
export const GET = createRoutine('PROTAGONISTAS/GET')
export const SUBMIT_PROFILE = createRoutine('PROTAGONISTAS/SUBMIT_PROFILE')
export const LOAD_PROTAGONISTAS = createRoutine('PROTAGONISTAS/LOAD')
